// src/i18n/es/payments.ts
// «Cobros» (mockup 08) — route /payments, Dirección. No visible para Recepción;
// los totales de dinero se ocultan siempre para Recepción.
export const payments = {
  name: 'Cobros |||| Cobros',
  subtitle: 'Cuánto se ha cobrado, por qué canal y con qué medio de pago',

  tiles: {
    amount: 'Cobrado',
    reservations: 'Reservas con cobro',
    pctOfArrivals: '% de llegadas',
    amountDetail: '%{count} reserva con cobro · %{pct} de las llegadas |||| %{count} reservas con cobro · %{pct} de las llegadas',
    // P02: «llegadas» only when the hotels share their reservation list.
    amountDetailRoommatik:
      '%{count} reserva con cobro · %{pct} de las reservas con actividad en Roommatik |||| %{count} reservas con cobro · %{pct} de las reservas con actividad en Roommatik',
    amountDetailMixed:
      '%{count} reserva con cobro · %{pct} de las llegadas y reservas con actividad |||| %{count} reservas con cobro · %{pct} de las llegadas y reservas con actividad',
    amountDetailNoPct: '%{count} reserva con cobro |||| %{count} reservas con cobro',
    average: 'Media por reserva',
    median: 'Mediana por reserva',
    // Matches Resumen's «Cobrado en autoservicio», which leaves out the staff-run Air Lobby.
    selfServiceDetail: 'De ello, en autoservicio %{amount} (sin Air Lobby)',
    refundsDetail: 'Descontadas %{count} devolución (%{amount}) |||| Descontadas %{count} devoluciones (%{amount})',
    preAuthorizations: 'Preautorizaciones no incluidas: %{count}',
    mixedCurrencies: 'Varias monedas: se muestran por separado, nunca sumadas',
    notMeasurable: 'Sin dato: alguna reserva del periodo tiene un cobro sin el detalle de sus operaciones.',
  },

  axis: {
    arrival: 'Fecha de llegada',
    payment: 'Fecha de cobro',
  },

  byChannel: {
    title: 'Por canal',
    columns: { channel: 'Canal', currency: 'Moneda', reservations: 'Reservas', amount: 'Cobrado', pct: '%' },
    noChannel: 'Sin canal',
  },

  byMethod: {
    title: 'Por medio de pago',
    description: 'Cargos por medio de pago; las devoluciones, en su propia fila, en negativo.',
    columns: { method: 'Medio', currency: 'Moneda', reservations: 'Reservas', amount: 'Importe', failed: 'Fallidos' },
    methods: {
      cardTerminal: 'Tarjeta en terminal',
      cardOnline: 'Tarjeta online',
      cash: 'Efectivo',
      preauthorization: 'Preautorización',
      unknown: 'No especificado',
      refund: 'Devoluciones',
    },
  },

  byHotel: {
    title: 'Por instalación',
    columns: {
      hotel: 'Instalación',
      currency: 'Moneda',
      arrivals: 'Llegadas',
      reservations: 'Reservas con cobro',
      pct: '%',
      amount: 'Cobrado',
      average: 'Media',
      previousAmount: 'Periodo anterior',
    },
  },

  help: {
    title: 'Cobros',
    description:
      'Cobrado = cargos firmes menos devoluciones, en todos los canales (kiosco, móvil, online y Air Lobby), sin preautorizaciones y por moneda: dos monedas nunca se suman. «En autoservicio» es la parte cobrada sin personal (kiosco, móvil y online); Air Lobby lo opera el personal del hotel.',
    features: {
      axis: 'Por fecha de llegada: todas las operaciones de las reservas que llegan en el periodo. Por fecha de cobro: las operaciones hechas en el periodo, por el día del hotel; con este eje no se calcula el % de llegadas.',
      arrivals: 'El % de llegadas usa las mismas llegadas que Resumen: las de la lista de reservas del hotel, sin canceladas ni no presentados, cuando el hotel la comparte; si no, las reservas con actividad en Roommatik. Cuenta las llegadas con algún cargo firme.',
      methods: '«Fallidos» cuenta reservas cuyo pago terminó fallido y que no tienen ningún cargo en la selección: una reserva nunca es a la vez cobrada y fallida.',
    },
    tips: {
      hidden: 'Esta página no está disponible para el rol de recepción.',
    },
  },
};

export default payments;
